

import React, { useState, useEffect } from "react";
import { Tab, Message, Button } from "semantic-ui-react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import axiosInstance from "../../lib/auth/axiosApi";
import MonarchCredentials from "../../components/Monarch/MonarchCredentials";
import MonarchDashboard from "../../components/Monarch/MonarchDashboard";
import MonarchAccounts from "../../components/Monarch/MonarchAccounts";
import MonarchDebt from "../../components/Monarch/MonarchDebt";
import MonarchMonthlyAverages from "../../components/Monarch/MonarchMonthlyAverages";

function DijonFinance(props) {
  const [hasCredentials, setHasCredentials] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    checkCredentials();
  }, []);

  const checkCredentials = async () => {
    try {
      const response = await axiosInstance.get("/monarch/has_credentials/");
      setHasCredentials(response.data.has_credentials);
    } catch (err) {
      console.error("Error checking credentials:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCredentialsSaved = () => {
    setHasCredentials(true);
  };

  const handleDisconnect = async () => {
    try {
      await axiosInstance.delete("/monarch/remove_credentials/");
      setHasCredentials(false);
    } catch (err) {
      console.error("Error removing credentials:", err);
    }
  };

  const panes = [
    {
      menuItem: 'Dashboard',
      render: () => (
        <Tab.Pane>
          <MonarchDashboard />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Monthly Averages',
      render: () => (
        <Tab.Pane>
          <MonarchMonthlyAverages />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Accounts',
      render: () => (
        <Tab.Pane>
          <MonarchAccounts />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Debt',
      render: () => (
        <Tab.Pane>
          <MonarchDebt />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div id="finance">
      <DijonCard
        width={'100%'}
        height={'100vh'}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={'finance'}
        content={
          <div className={"container mx-auto px-4"} style={{
              height: '100%',
              overflow: 'auto',
              padding: '20px'
          }}>
            {!hasCredentials ? (
              <MonarchCredentials onCredentialsSaved={handleCredentialsSaved} />
            ) : (
              <div>
                <div style={{ marginBottom: '20px', textAlign: 'right' }}>
                  <Button 
                    negative 
                    size="small"
                    onClick={handleDisconnect}
                  >
                    Disconnect Monarch Account
                  </Button>
                </div>
                <Tab 
                  panes={panes} 
                  activeIndex={activeIndex}
                  onTabChange={(e, { activeIndex }) => setActiveIndex(activeIndex)}
                />
              </div>
            )}
          </div>
        }
      />
    </div>
  );
}

export default DijonFinance;
